/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Map all boolean fields set in billing pipeline API
 */
export interface BillingPipelineTaskSpec { 
    update_billing_entities?: boolean;
    update_raw_usage?: boolean;
    update_entity_and_org_summary?: boolean;
    update_event_history?: boolean;
    update_org_overage_enforcement?: boolean;
    update_processed_subscription?: boolean;
    update_incorta_subscription?: boolean;
    update_subscription_history?: boolean;
    upsert_sddc_quota?: boolean;
}

